
import React from "react";

/**
 * Format a HTML element object
 *
 * @param elm [object] The HTML element object
 * @param count [int] The current key
 *
 * @return react object
 */
const formatElement = ( elm, count, logicFn, templateFn ) => {
    if( typeof elm == 'string' ){
        return elm.replace(/\${_([\w_-]+)}/g, templateFn);
    } else if ( typeof elm.type != "undefined" ){
        let isVisible = true;
        if( typeof elm.conditions != "undefined" ){
            isVisible = logicFn( elm.conditions );
        }
        if( !isVisible )
            return null;
        let className = elm.className ?? '';
        
        if( typeof elm.content != "undefined" ){
            return React.createElement(elm.type, {key:count,className:className}, formatElement(elm.content, ++count, logicFn, templateFn));
        } else {
            return React.createElement(elm.type, {key:count,className:className});
        }
        
    } else { //is an array of elements
        let elms = [];
        elm.forEach((inrElm) => {
            elms.push(formatElement(inrElm, ++count, logicFn, templateFn));
        });
        return elms;
    }
};
 
export default formatElement;
